import { Icon } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import React from 'react';
type CartCloseIcon = ComponentProps<typeof Icon>;
const CartCloseIcon = ({
  ...props
}: CartCloseIcon) => {
  return <Icon width="24px" height="24px" {...props} data-sentry-element="Icon" data-sentry-component="CartCloseIcon" data-sentry-source-file="CartCloseIcon.tsx">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" data-sentry-element="svg" data-sentry-source-file="CartCloseIcon.tsx">
        <circle cx="50" cy="50" r="45" fill="transparent" stroke="black" strokeWidth="4" data-sentry-element="circle" data-sentry-source-file="CartCloseIcon.tsx" />
        <path d="M35 35 L65 65 M65 35 L35 65" stroke="black" strokeWidth="8" strokeLinecap="round" data-sentry-element="path" data-sentry-source-file="CartCloseIcon.tsx" />
      </svg>
    </Icon>;
};
export default CartCloseIcon;